export default Object.freeze({
    SEA: "SEA",
    LEA: "LEA",
    SCH: "SCH"
})